<template>
  <div class="md-layout-item md-gutter image-section-size md-size-100 md-small-size-100 md-xsmall-size-100">
    <div class="image-header">
      <h5 class="section-title">Image*</h5>
      <h6 v-if="!this.image && !imageByLink" class="alert-color">Mandatory Field</h6>
    </div>
    <div class="small-screen-adjustments image-box">
      <div class="ui-block d-flex justify-content-center image-box dashed-modal" :class="[{'no-image': !this.image && !imageByLink}]">
        <div
          v-cloak
          @drop.prevent="onFileChange"
          @dragover.prevent
          :class="[
            {
              'modal-style': !image,
              'modal-style-image': image,
              'text-center': image,
            },
          ]"
        >
          <div class="text-center">
            <img
              alt="Item"
              v-if="image"
              id="itemPostImage"
              class="p-2"
              style="max-height: 245px"
              :style="exif_rotate"
              :src="itemPostFeaturedImage"
            />
            <img
              alt="Item"
              v-if="imageByLink && !image"
              id="itemPostImage"
              class="p-2"
              style="max-height: 245px"
              :style="exif_rotate"
              :src="imageByLink"
            />
            <div class="upload">
              <em
                class="material-icons-outlined cloud-image mt-4"
                width="44px"
                height="44px"
                v-if="!image && !imageByLink"
              >
                backup
              </em>
              <div v-if="!image && !imageByLink" class="mx-2">
                <h5 class="drag-text mt-4">Drag and drop here</h5>
              </div>
              <input
                type="file"
                ref="fileInput"
                class="upload"
                style="display: none"
                @change="onFileChange"
                accept="image/*"
                data-cy="inputImageFile"
              />
              <span v-if="!image && !imageByLink" class="d-block img-size-text mt-4"
                >Maximum size: 3.5MB</span
              >

              <div v-if="!valid_img" class="error-box mt-2 mb-2 mr-1 ml-1">
                <span
                  >Sorry, this file is invalid, please upload an PNG/JPEG/JPG
                  image file</span
                >
              </div>

              <div v-if="heavy_img" class="error-box mt-1 mr-1 ml-1">
                <span
                  >Sorry, your image is too large, please select another
                  image</span
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="btn-upload-content">
      <SButtonMaterial
        :md-ripple="false"
        buttonType="button"
        color="transparent"
        textColor="primary"
        text="Upload file"
        class="btn-size"
        borderColor="primary"
        borderRadius="small"
        materialClass="dense"
        @button="trigger"
        v-if="!image && !imageByLink"
      />
      <SButtonMaterial
        :md-ripple="false"
        buttonType="button"
        color="transparent"
        textColor="primary"
        text="Clear"
        class="btn-size"
        borderColor="primary"
        borderRadius="small"
        materialClass="dense"
        @button="clearFile"
        v-if="image || imageByLink"
      />
    </div>
  </div>
</template>

<script>
import ImageModule from "@/modules/Image";
import { mapActions, mapGetters } from "vuex";
import ItemHelperVue from "../../mixins/ItemHelper.vue";
import SButtonMaterial from "@/material-components/atoms/SButtonMaterial.vue";

export default {
  name: "ItemPostImage",
  mixins: [ItemHelperVue],
  components: {
    SButtonMaterial,
  },
  data() {
    return {
      image: null,
      image_file: "",
      image_size_limit: 3670016,
      progress: 0,
      imageByLink: null,
      upload_complete: false,
      valid_img: true,
      heavy_img: false,
      exif_rotate: "",
    };
  },
  computed: {
    ...mapGetters({
      itemPostFeaturedImage: "getNewItemImage",
      imageFile: "getImageFile",
      isbnImageLink: "getISBNImageLink",
    }),
  },
  watch: {
    image: function () {
      this.setImage({ image: this.image });
      this.setImageFile({ imageFile: this.image_file });
      this.$emit("file", this.image_file);
      this.storeItemSession();
    },
    newitem_image_orientation: function (val) {
      this.updateImageOrientation(val);
    },
    itemPostFeaturedImage() {
      this.image = this.itemPostFeaturedImage;
      this.image_file = this.imageFile;
    },
    isbnImageLink() {
      this.imageByLink = this.isbnImageLink;
    },
  },
  methods: {
    ...mapActions(["setImage", "setImageFile", "setImageOrientation"]),
    trigger() {
      this.$refs.fileInput.click();
    },
    clearFile() {
      this.image_file = "";
      this.$refs.fileInput.value = null;
      this.imageByLink = "";
      this.resetItemImage();

    },
    onFileChange(e) {
      const files = e.target.files || e.dataTransfer.files;
      if (files[0].size > this.image_size_limit) {
        this.heavy_img = true;
        this.image = null;
        return false;
      }
      if (!files.length) {
        return false;
      } else if (
        files[0]["type"] !== "image/jpeg" &&
        files[0]["type"] !== "image/png"
      ) {
        this.valid_img = false;
        this.image = null;
        return false;
      }

      this.valid_img = true;
      this.heavy_img = false;
      this.loadImage(files[0]);
    },
    loadImage(file) {
      ImageModule.getOrientation(file, (orientation) => {
        this.setImageOrientation({ imageOrientation: orientation });
      });
      const reader = new FileReader();
      const vm = this;
      vm.image_file = file;
      reader.onload = (e) => {
        vm.image = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    updateImageOrientation(val) {
      let self = this;
      // self.exif_rotate = 'display: none;'
      self.exif_rotate = "";
      switch (val) {
        case 1:
        case -1:
          self.exif_rotate += "";
          break;
        case 2:
          self.exif_rotate += "transform: scale(-1, 1)";
          break;
        case 3:
          self.exif_rotate += "transform: rotate(180deg)";
          break;
        case 4:
          self.exif_rotate +=
            "transform: rotate(180deg);transform: scale(-1, 1)";
          break;
        case 5:
          self.exif_rotate +=
            "transform: rotate(90deg);transform: scale(-1, 1)";
          break;
        case 6:
          self.exif_rotate += "transform: rotate(90deg)";
          break;
        case 7:
          self.exif_rotate +=
            "transform: rotate(270deg);transform: scale(-1, 1)";
          break;
        case 8:
          self.exif_rotate += "transform: rotate(270deg)";
          break;
      }
    },
    retrieveImageFromClipboardAsBlob(pasteEvent, callback) {
      if (pasteEvent.clipboardData === false) {
        if (typeof callback === "function") {
          callback(undefined);
        }
      }

      const items = pasteEvent.clipboardData.items;

      if (items === undefined) {
        if (typeof callback == "function") {
          callback(undefined);
        }
      }
      for (const element of items) {
        if (element.type.indexOf("image") === -1) continue;
        let blob = element.getAsFile();
        if (typeof callback === "function") {
          callback(blob);
        }
      }
    },
  },
  created() {
    window.addEventListener(
      "paste",
      (event) => {
        if ($("#new-item").is(":visible")) {
          this.retrieveImageFromClipboardAsBlob(event, (imageBlob) => {
            this.loadImage(imageBlob);
          });
        }
      },
      false
    );
  },
  mounted() {
    if (this.itemPostFeaturedImage) {
      this.image = this.itemPostFeaturedImage;
      this.image_file = this.imageFile;
    }
    if (this.isbnImageLink) {
      this.imageByLink = this.isbnImageLink;
    }
  },
};
</script>

<style lang="scss" scoped>
.upload {
  display: inline-block;
  margin-top: 2.5rem;
  text-align: center;
  cursor: default;
}
.image-section-size {
  width: 300px;
  min-width: unset;
}
.image-box {
  width: 300px;
  height: 240px;
  margin-bottom: 10px;
}
.modal-style {
  height: 250px;
  max-height: 300px;
  margin-bottom: 10px;
}
.button-style {
  color: white;
  background-color: #63bab9;
}
.btn-size {
  width: 115px;
}
.svg-color {
  fill: #c2c5d9;
}
.image-header {
  display: flex;
  justify-content: space-between;
}
.dashed-modal {
  border: 2px dashed $dark;
  min-width: 250px;
  max-width: 385px;
  margin: auto;
}
.no-image {
  border: 2px dashed red !important;
}
.alert-color {
  color: red;
}
.cloud-image {
  font-size: 44px;
  color: $dark;
}

.img-size-text {
  font-weight: 500 !important;
}

.drag-text,
.img-size-text {
  font-style: normal;
  font-weight: 600;
  line-height: 6px;
  letter-spacing: 1.25px;
  color: rgba(0, 0, 0, 0.78);
}

.btn-upload-content {
  display: flex;
  justify-content: center;
  align-items: center;
}

.section-title {
  font-style: normal;
  font-weight: normal;
  line-height: 20px;
  letter-spacing: 1.25px;
  color: rgba(0, 0, 0, 0.9);
  font-size: 16px;
}
@media screen and (max-width: 1198px) {
  .small-screen-adjustments {
    display: flex;
    justify-content: center;
  }
}
@media screen and (max-width: 450px) {
  .small-screen-adjustments {
    display: flex;
    justify-content: center;
  }
  .dashed-modal {
    min-width: 100%;
  }
}
</style>
